const classes = {
	title: "Oppkjøringsklasse",
	new_classes: "Ny klasse",
	edit_classes: "Endre klasse: {name}",
	view_classes: "Vis klasse: {name}",
	list_title: "Oppkjøringsklasser",
	list_subtitle: "Håndtere klasser",
	create_title: "Legg til klasse",
	update_title: "Endre klasse",
	details_title: "Klasse detaljer",
	id: "ID",
	name: "Navn",
	active: "Aktiv",
	inactive: "Inaktiv",
	duration: "Varighet",
	status: "Status",
	duration_type: "Type",
	min: "Min",
	hours: "Timer",
	coursetype_id: "Kompetansegruppe",
	coursetypegroup_id: "Kompetanseområde",
};
export default classes;